import React from 'react';
import {NewsCard} from '@yandex-data-ui/page-constructor';

import {PostProps} from 'units/constructor-local/models';
import withLocale, {WithLocaleProps} from 'hoc/withLocale';
import {format} from 'utils';

export type PostPropsFull = PostProps & WithLocaleProps;

const Post: React.FC<PostPropsFull> = (props) => {
    const {date, title, border, locale, url} = props;
    const formattedDate = format(date, 'longDate', locale.code);

    return <NewsCard date={formattedDate} isoDate={date} title={title} border={border} url={url} />;
};

export default withLocale(Post);
